import { useState } from "react";
import { TooltipStandard } from "../../../../Utility/TooltipStandard";
import { OverlayTrigger } from "react-bootstrap";

// For this filter, we need to notify the parent component when a status is selected
// so that it can switch to "fetch all" mode if not already in that mode.
// This is because the status filter needs to be applied on the client side
function StatusColumnFilter({
  switchToFetchAllMode,
  column,
  isClientSideRendering,
  canFilterByStatus = true,
  isFetchingAllOrders = false,
  isEnabledAllOrders = true,
  maxDateRangeForStatusFilter,
}) {
  const { setFilter, filterValue } = column;

  const [statusOption, setStatusOption] = useState(
    isClientSideRendering ? filterValue || "" : "",
  );

  const onChange = (event) => {
    setStatusOption(event.target.value);

    if (isClientSideRendering) {
      // on client-side-table use the built-in setFilter
      setFilter(event.target.value); // Set undefined to remove the filter entirely
    }

    switchToFetchAllMode(isClientSideRendering, event.target.value);
  };

  if (isFetchingAllOrders) {
    return (
      <select
        className="form-control form-control-sm order-history-table-filters"
        disabled
      >
        <option value="">Loading...</option>
      </select>
    );
  }

  if (!canFilterByStatus) {
    return (
      <OverlayTrigger
        key="status-filter-disabled"
        flip
        placement="top"
        overlay={
          isEnabledAllOrders ? (
            <span></span> //gets console errors about arrowprops not being a valid property on a dom element, but otherwise would have to wrap a whole duplicate of the component
          ) : (
            <TooltipStandard id="group-reoorder-tooltip">
              Status filtering is disabled for date ranges over{" "}
              {maxDateRangeForStatusFilter} days.
            </TooltipStandard>
          )
        }
      >
        <select
          className="form-control form-control-sm order-history-table-filters"
          disabled
        >
          <option value="">All</option>
        </select>
      </OverlayTrigger>
    );
  }
  return (
    <select
      className="form-control form-control-sm order-history-table-filters"
      value={statusOption}
      onChange={onChange}
    >
      <option value="">All</option>
      <option value="Open">Open</option>
      <option value="In Transit">In Transit</option>
      <option value="Out For Delivery">Out for Delivery</option>
      <option value="Partial Delivery">Partial Delivery</option>
      <option value="Delivered">Delivered</option>
      <option value="Possible Exception">Possible Exception</option>
    </select>
  );
}

export default StatusColumnFilter;
